<template>
  <div class="switch-tenant">
    <div class="switch-tenant-header">
    </div>
    <cube-scroll
      ref="scroll"
      :data="tenants"
      :options="cubeScrollOptions"
      class="cube-scroll-margin-top"
      @pulling-down="queryTenant">
      <template v-for="tenant in tenants">
        <tenant-card :key="tenant.id" :data="tenant" @click="handleSwitch(tenant.id)" />
      </template>
      <div class="empty-org">
        <div class="select-option join-org" @click="pushJoinOrg">
          <div class="option-prefix">
            <x-svg-icon name="join-org"></x-svg-icon>
          </div>
          <div class="option-info">
            <span class="info-title">加入已有组织</span>
            <span class="info-desc">被其他人邀请使用</span>
          </div>
          <div class="option-suffix">
            <x-svg-icon name="arrow-right-icon"></x-svg-icon>
          </div>
        </div>
        <div class="select-option" @click="pushCreateOrg">
          <div class="option-prefix">
            <x-svg-icon name="create-org"></x-svg-icon>
          </div>
          <div class="option-info">
            <span class="info-title">创建新的组织</span>
            <span class="info-desc">为企业或团队创建新的组织</span>
          </div>
          <div class="option-suffix">
            <x-svg-icon name="arrow-right-icon"></x-svg-icon>
          </div>
        </div>
      </div>
    </cube-scroll>
  </div>
</template>

<script>
import TenantCard from '@/components/tenant-card/tenant-card.vue'
import apis from '@/api/index'
import { mapMutations, mapState } from 'vuex'
import ParamsCatchMixin from '@/mixin/params-catch.mixin.js'
import {
  SET_CURRENT_ORG,
  SET_DAPTENAT_VERSION
} from '@/store/tenant.store.js'
import { SET_ORGS } from '@/store/auth.store.js'
export default {
  components: {
    TenantCard
  },
  mixins: [ParamsCatchMixin],
  data () {
    return {
      cubeScrollOptions: {
        pullDownRefresh: {
          txt: this.$t('common.scroll.refreshSuccess')
        },
        scrollbar: false
      }
    }
  },
  computed: {
    ...mapState({
      tenants: (state) => state.authModule.orgs
    })
  },
  created() {
    this.queryTenant(true)
  },
  methods: {
    ...mapMutations('tenantModule', {
      setCurrentOrg: SET_CURRENT_ORG,
      setDaptenatVersion: SET_DAPTENAT_VERSION
    }),
    ...mapMutations('authModule', {
      setOrgs: SET_ORGS
    }),
    handleSwitch(id) {
      const request = {
        ...apis.PERSONAL_CENTER.SWITCH_TENANT,
        params: {
          id: id
        }
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.proxySetCurrentOrg(resp.data).then(() => {
              this.$router.replace({
                name: 'personal-center',
                params: {
                  orgId: resp.data.id
                }
              })
            })
          },
          () => {}
        )
        .asyncErrorCatch((error) => {})
    },
    proxySetCurrentOrg(org) {
      const request = { ...apis.WORKBENCH.QUERY_USER_TENANT_INFO }
      request.params = {
        tenantId: org.id
      }
      return this.$request(request)
        .asyncThen(
          (resp) => {
            this.setCurrentOrg(resp.data)
            this.setDaptenatVersion(resp.data.limitId)
          },
          (error) => {
            this.setCurrentOrg(org)
            this.setDaptenatVersion()
          }
        )
        .asyncErrorCatch((error) => {
          this.setCurrentOrg(org)
          this.setDaptenatVersion()
        })
    },
    queryTenant(flag) {
      const request = { ...apis.WORKBENCH.QUERY_MY_TENANT_LIST }
      if (flag) {
        this.$loading.show()
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.tenants = resp.data
            this.setOrgs(resp.data)
            this.$refs.scroll.forceUpdate()
            this.$loading.hide()
            if (resp.data.length < 1) {
              this.setCurrentOrg({})
            }
          },
          () => {
            this.$refs.scroll.forceUpdate()
            this.$loading.hide()
          }
        )
        .asyncErrorCatch((error) => {
          this.$refs.scroll.forceUpdate()
          this.$loading.hide()
        })
    },
    pushJoinOrg() {
      this.$router.push({ name: 'org-join' })
    },
    pushCreateOrg() {
      this.$router.push({ name: 'org-create' })
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.switch-tenant {
  width: 100%;
  height: 100%;
  position: relative;
  max-height: 100vh;
  background-color: #F7F7F7;
  .switch-tenant-header {
    //height: 2.75rem;
    display: flex;
    font-size: 16px;
    background-color: #FFFFFF;
    margin-bottom: 0.5rem;
    .left-arrow {
      margin-left: 1rem;
      margin-top: 9px;
      width: 2rem;
      > .x-svg-icon .svg-icon{
        color: $--app-notice-font-color;
      }
    }
    .switch-tenant-title {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 6px;
    }
  }
  .tenant-card {
    height: 4.5rem;
    padding-top: 0.7rem;
  }
  .empty-org {
    margin-top: 0.8rem;
    background-color: #FFFFFF;
    .join-org {
      border-bottom: 1px solid $--app-split-line-color;
      background-color: #FFFFFF;
    }
    .select-option {
      display: flex;
      align-items: center;
      height: 4.5rem;
      //margin: 20px 0;
      padding: 24px 14px;
      //border-bottom: 1px solid $--app-split-line-color;
      border-radius: $--app-base-border-radius;
      //box-shadow: 0 0 8px 0 $--app-split-line-color;
      box-sizing: border-box;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
      .option-prefix, .option-suffix {
        flex: 0 0 48px;
        display: flex;
        .x-svg-icon .svg-icon {
          width: 40px;
          height: 40px;
        }
      }
      .option-prefix {
        justify-content: center;
        .x-svg-icon .svg-icon{
          width: 40px !important;
          height: 40px !important;
        }
      }
      .option-suffix {
        justify-content: flex-end;
        > .x-svg-icon .svg-icon{
          color: $--app-notice-font-color;
        }
      }
      .option-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 14px;
        .info-title {
          font-size: 14px;
          font-weight: $--app-base-font-weight;
          color: $--app-base-font-color;
          margin-bottom: 10px;
        }
        .info-desc {
          color: $--app-notice-font-color;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
